/** Глобальная цветовая тема интерфейса, сохраняемая между посещениями. */
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ColorTheme = "light" | "dark";

interface ThemeState {
	colorTheme: ColorTheme;
	toggleColorTheme: () => void;
}

const applyColorTheme = (colorTheme: ColorTheme) => {
	document.documentElement.dataset.theme = colorTheme;
};

export const useThemeStore = create<ThemeState>()(
	persist(
		(set, get) => ({
			colorTheme: "light",
			toggleColorTheme: () => {
				const colorTheme = get().colorTheme === "light" ? "dark" : "light";
				applyColorTheme(colorTheme);
				set({ colorTheme });
			},
		}),
		{
			name: "gridplanner-color-theme",
			onRehydrateStorage: () => (state) => applyColorTheme(state?.colorTheme ?? "light"),
		},
	),
);
